import en from 'messages/messages.en.json';
import fr from 'messages/messages.fr.json';

export const messages = {
    en,
    fr
};

export type TranslationKeys = string;
